import { useState } from "react"
import { createPortal } from "react-dom"
import { motion, AnimatePresence } from "framer-motion"
import { Menu, X } from "lucide-react"
import { NavLinks } from "./NavLinks"
import { Button } from "../ui/button"
import Link from "next/link"

interface MobileMenuProps {
    bookingHref: string;
}

export const MobileMenu = ({ bookingHref }: MobileMenuProps) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className="lg:hidden">
            <button
                onClick={() => setIsOpen(true)}
                className="p-2 text-foreground/80 hover:text-primary transition-colors"
                aria-label="Open menu"
            >
                <Menu className="w-6 h-6" strokeWidth={1.5} />
            </button>

            {typeof document !== "undefined" && createPortal(
                <AnimatePresence>
                    {isOpen && (
                        <>
                            {/* Backdrop */}
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                onClick={() => setIsOpen(false)}
                                className="fixed inset-0 bg-background/80 backdrop-blur-md z-60"
                            />

                            {/* Menu Panel */}
                            <motion.div
                                initial={{ x: "100%" }}
                                animate={{ x: 0 }}
                                exit={{ x: "100%" }}
                                transition={{ type: "spring", damping: 25, stiffness: 200 }}
                                className="fixed top-0 right-0 bottom-0 w-[80%] max-w-sm bg-card border-l border-border/50 z-70 shadow-2xl p-12 flex flex-col"
                            >
                                <div className="flex justify-end mb-12">
                                    <button
                                        onClick={() => setIsOpen(false)}
                                        className="p-2 text-foreground/60 hover:text-primary transition-colors"
                                        aria-label="Close menu"
                                    >
                                        <X className="w-8 h-8" strokeWidth={1} />
                                    </button>
                                </div>

                                <NavLinks
                                    className="flex-col items-start gap-10 mb-auto"
                                    onLinkClick={() => setIsOpen(false)}
                                />

                                <div className="pt-12 border-t border-border/50 mt-12">
                                    <Button
                                        asChild
                                        className="h-14 w-full rounded-full bg-white text-sm font-medium tracking-wide text-stone-950 hover:bg-stone-100"
                                    >
                                        <Link href={bookingHref} onClick={() => setIsOpen(false)}>
                                            Book Now
                                        </Link>
                                    </Button>
                                </div>
                            </motion.div>
                        </>
                    )}
                </AnimatePresence>,
                document.body
            )}
        </div>
    )
}
